<script>
import { orderTypes } from "@/store/types/types.js";
import * as moment from "moment";
export default {
  name: "MealCalcModal",
  data() {
    return {
      orderList: [],
      date: "",
      year: "",
      month: "",
      day: "",
      printList: "",
      checkAll: false,
      smallMealCustomer: 0,
      largeMealCustomer: 0,
      rice: 0,
      smallTablewareMealCustomer: 0,
      largeTablewareMealCustomer: 0,
      tablewareRice: 0,
      tablewareCustomerLabel: [],
      customerLabel: [],
      search: ""
    };
  },
  computed: {
    orderAllList: {
      get() {
        return this.$store.getters[orderTypes.getters.getOrderList].filter(
          order => {
            return order.delivered_at === this.date;
          }
        );
      }
    }
  },
  methods: {
    filterOrder() {
      this.orderList = this.orderAllList.filter(order => {
        if (!order.kitchen_comment) return;
        return order.kitchen_comment.includes(this.search);
      });
      if (!this.search) this.orderList = this.orderAllList;
    },
    goToPreDay() {
      this.reset();
      this.date = moment(this.date)
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      this.year = this.date.split("-")[0];
      this.month = this.date.split("-")[1];
      this.day = this.date.split("-")[2];
      this.$store
        .dispatch(orderTypes.actions.QUERY_TODAY_ORDER_LIST, this.date)
        .then(() => {
          this.calcCustomer();
          this.calcTablewareCustomer();
        });
    },
    goToNextDay() {
      this.reset();
      this.date = moment(this.date)
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.year = this.date.split("-")[0];
      this.month = this.date.split("-")[1];
      this.day = this.date.split("-")[2];
      this.$store.dispatch;
      this.$store
        .dispatch(orderTypes.actions.QUERY_TODAY_ORDER_LIST, this.date)
        .then(() => {
          this.calcCustomer();
          this.calcTablewareCustomer();
        });
    },
    calcCustomer() {
      this.orderList.forEach(order => {
        if (order.is_tableware) return;
        if (order.description.includes("2～3人")) {
          this.smallMealCustomer += 1;
        }
        if (order.description.includes("3～4人")) {
          this.largeMealCustomer += 1;
        }
        if (!order.customized_label) order.customized_label = "";
        this.rice = this.rice + order.rice;

        this.customerLabel.push(order.customized_label);
      });
    },
    calcTablewareCustomer() {
      this.orderList.forEach(order => {
        if (!order.is_tableware) return;
        if (order.description.includes("2～3人")) {
          this.smallTablewareMealCustomer += 1;
        }
        if (order.description.includes("3～4人")) {
          this.largeTablewareMealCustomer += 1;
        }
        if (!order.customized_label) order.customized_label = "";
        // if (!order.tablewareRice) order.tablewareRice = 0;
        this.tablewareRice = this.tablewareRice + order.rice;
        this.tablewareCustomerLabel.push(order.customized_label);
      });
    },
    reset() {
      this.smallMealCustomer = 0;
      this.largeMealCustomer = 0;
      this.rice = 0;
      this.smallTablewareMealCustomer = 0;
      this.largeTablewareMealCustomer = 0;
      this.tablewareRice = 0;
      this.tablewareCustomerLabel = [];
      this.customerLabel = [];
    }
  },
  watch: {
    orderAllList: {
      handler(val) {
        this.orderList = val;
      },
      deep: true
    }
  },
  mounted() {
    this.date = moment().format("YYYY-MM-DD");
    this.year = this.date.split("-")[0];
    this.month = this.date.split("-")[1];
    this.day = this.date.split("-")[2];
    this.$store
      .dispatch(orderTypes.actions.QUERY_TODAY_ORDER_LIST, this.date)
      .then(data => {
        this.orderList = data.filter(order => {
          return order.delivered_at === this.date;
        });
        this.calcCustomer();
        this.calcTablewareCustomer();
      });
  }
};
</script>

<template src="./template.html"></template>
<style lang="scss" src="./style.scss"  />
